import { Navigate, Outlet, useLocation } from "react-router-dom";
import { localStorageService } from "../services";

export const ProtectedRoute = () => {
  const location = useLocation();

  const isAuthenticated = () => {
    const token = localStorageService.getItem("token");
    return !!token;
  };

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};
